import React from 'react';
import Image from '@widgets/image/image';
/**
 * Adapter for Elementor basic "image" widget.
 * Converts Elementor image settings (link_to, link, open_lightbox) to ltg-image format.
 */
export default function ElementorImage(props) {
    var _a;
    const { image, link_to, link, open_lightbox } = props;
    if (!(image === null || image === void 0 ? void 0 : image.url))
        return null;
    const imageData = {
        id: (_a = image.id) !== null && _a !== void 0 ? _a : 0,
        url: image.url,
        alt: image.alt,
        srcset: image.srcset,
    };
    const lightbox = link_to === 'file' && open_lightbox === 'yes' ? 'yes' : undefined;
    const url = link_to === 'custom' && (link === null || link === void 0 ? void 0 : link.url) ? link.url : undefined;
    const url__props = (link === null || link === void 0 ? void 0 : link.is_external)
        ? { type: 'url', lang: '', blank: true }
        : undefined;
    return (React.createElement(Image, { image: imageData, lightbox: lightbox, url: url, url__props: url__props }));
}
